import styled from 'styled-components';

export const StatusContainer = styled.div`
  cursor: pointer;
  margin-bottom: 12px;
`;
